import { useTranslation } from "react-i18next";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const SubscribeToPlanModal = ({ subscribeToPlan, closeModal, selectedPlan, isActualsSelected }) => {
  const { t } = useTranslation();

  const planPrice = () => {
    if (isActualsSelected && selectedPlan.plan_id === "V2_Starter_Plan") {
      return 19 * 100;
    }

    return isActualsSelected ? selectedPlan.price_cents * 2 : selectedPlan.price_cents;
  };

  return (
    <TeambookDialog
      title={t("settings.subscription.name")}
      open
      onClose={closeModal}
      withCloseButton
      content={
        <p>
          {t("settings.subscription.are_you_sure", {
            price: (planPrice() / 100).toString(),
          })}
        </p>
      }
      actionButtons={[
        {
          text: t("yes"),
          onClick: subscribeToPlan,
        },
      ]}
    />
  );
};

SubscribeToPlanModal.propTypes = {
  subscribeToPlan: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectedPlan: PropTypes.object.isRequired,
  isActualsSelected: PropTypes.bool.isRequired,
}

export default SubscribeToPlanModal;
